// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.BulkHoldListings-module_root___xfTrL {
  width: 1100px;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.BulkHoldListings-module_top___Nfpg3 {
  display: flex;
  padding: 2rem 0;
  overflow: auto;
}
@media (max-width: 900px) {
  .BulkHoldListings-module_top___Nfpg3 {
    flex-direction: column;
  }
}

.theme--light .BulkHoldListings-module_left___Ogert {
  border-right: 1px solid #dddddd;
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}
.theme--dark .BulkHoldListings-module_left___Ogert {
  border-right: 1px solid #2f2f2f;
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}

.BulkHoldListings-module_right___uoVYs {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 540px;
  padding: 0 2rem;
  padding-top: 2rem;
}

.BulkHoldListings-module_mb___R1vFQ {
  margin-bottom: 16px;
}

.theme--light .BulkHoldListings-module_subHeader___yPm1L {
  color: #212121;
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--dark .BulkHoldListings-module_subHeader___yPm1L {
  color: #f0f0f0;
  font-size: 1.6rem;
  font-weight: 600;
}

.theme--light .BulkHoldListings-module_subHeaderSecondary___THk5J {
  color: #888888;
  font-size: 1.4rem;
}
.theme--dark .BulkHoldListings-module_subHeaderSecondary___THk5J {
  color: #a3a3a3;
  font-size: 1.4rem;
}

.theme--light .BulkHoldListings-module_fieldLabel___df59I {
  color: #212121;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 6px;
}
.theme--dark .BulkHoldListings-module_fieldLabel___df59I {
  color: #f0f0f0;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 6px;
}

.BulkHoldListings-module_durationSelect___ohd6X {
  width: 100%;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 1.4rem;
  cursor: pointer;
}
.theme--light .BulkHoldListings-module_durationSelect___ohd6X {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--dark .BulkHoldListings-module_durationSelect___ohd6X {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}

.theme--light .BulkHoldListings-module_helperText___QncNN {
  color: #888888;
  font-size: 1.2rem;
  line-height: 1.4;
  margin-top: 6px;
  margin-bottom: 16px;
}
.theme--dark .BulkHoldListings-module_helperText___QncNN {
  color: #a3a3a3;
  font-size: 1.2rem;
  line-height: 1.4;
  margin-top: 6px;
  margin-bottom: 16px;
}

.BulkHoldListings-module_commentsTextarea___jtF47 {
  resize: vertical;
  width: 100%;
  min-height: 100px;
  border-radius: 4px;
  padding: 8px;
  font-size: 1.4rem;
}
.theme--light .BulkHoldListings-module_commentsTextarea___jtF47 {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--dark .BulkHoldListings-module_commentsTextarea___jtF47 {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}

.BulkHoldListings-module_commentsTextarea___jtF47::placeholder {
  font-size: 1.4rem;
}

.theme--light .BulkHoldListings-module_warning___xFSAk {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}
.theme--dark .BulkHoldListings-module_warning___xFSAk {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}

.BulkHoldListings-module_warningHeader___fy44K {
  font-size: 1.4rem;
  font-weight: 600;
}

.BulkHoldListings-module_warningText___UvpsH {
  font-size: 1.2rem;
  font-weight: 400;
}

.theme--light .BulkHoldListings-module_rightTopHeaders___jSnwU {
  border-bottom: 1px solid #dddddd;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}
.theme--dark .BulkHoldListings-module_rightTopHeaders___jSnwU {
  border-bottom: 1px solid #2f2f2f;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}

.theme--light .BulkHoldListings-module_buttons___AFe5O {
  border-top: 1px solid #dddddd;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}
.theme--dark .BulkHoldListings-module_buttons___AFe5O {
  border-top: 1px solid #2f2f2f;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}

.BulkHoldListings-module_listings___ouEs7 {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  overflow: auto;
}

.theme--light .BulkHoldListings-module_singleListing___RBHTo {
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}
.theme--dark .BulkHoldListings-module_singleListing___RBHTo {
  border-top: 1px solid #2f2f2f;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}

.BulkHoldListings-module_singleListing___RBHTo[data-no-border=true] {
  border: none;
}

.theme--light .BulkHoldListings-module_xContainer___N88JV {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--dark .BulkHoldListings-module_xContainer___N88JV {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--light .BulkHoldListings-module_xContainer___N88JV div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #dddddd;
  transition: 200ms;
}
.theme--dark .BulkHoldListings-module_xContainer___N88JV div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #2f2f2f;
  transition: 200ms;
}
.theme--light .BulkHoldListings-module_xContainer___N88JV div:hover {
  padding: 2px;
  background: #888888;
}
.theme--dark .BulkHoldListings-module_xContainer___N88JV div:hover {
  padding: 2px;
  background: #a3a3a3;
}

.BulkHoldListings-module_itemTextPrimary___k58rn {
  font-size: 1.4rem;
  font-weight: 500;
}

.BulkHoldListings-module_secRowSeat___SCR_j {
  flex-grow: 1;
  min-width: 20px;
}

.BulkHoldListings-module_headerSecRowSeat___KCy7h {
  padding: 0.6rem;
}

.BulkHoldListings-module_secRowSeatCont___I5Ya_ {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BulkHoldListings-module_textSecondary___omxZH {
  font-size: 1.2rem;
  font-weight: 400;
}

.theme--light .BulkHoldListings-module_duration___RNC_f {
  color: #888888;
  width: 80px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkHoldListings-module_duration___RNC_f {
  color: #a3a3a3;
  width: 80px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkHoldListings-module_existingComments___Kz65H {
  color: #888888;
  width: 150px;
  padding: 0.6rem;
  flex-shrink: 0;
  font-size: 1.2rem;
  line-height: 1.3;
}
.theme--dark .BulkHoldListings-module_existingComments___Kz65H {
  color: #a3a3a3;
  width: 150px;
  padding: 0.6rem;
  flex-shrink: 0;
  font-size: 1.2rem;
  line-height: 1.3;
}

.theme--light .BulkHoldListings-module_qty___rHOZp {
  color: #888888;
  width: 50px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkHoldListings-module_qty___rHOZp {
  color: #a3a3a3;
  width: 50px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkHoldListings-module_priceLabel___PayUW {
  color: #888888;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkHoldListings-module_priceLabel___PayUW {
  color: #a3a3a3;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/bulkHoldListings/BulkHoldListings.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAmBD;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,cAAA;AAmBD;AAjBC;EALD;IAME,sBAAA;EAoBA;AACF;;ADmEE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAmBF;ADyDE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA4BF;;AAxBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA2BD;;AAxBA;EACC,mBAAA;AA2BD;;ADkCE;ECxDA,cAAA;EACA,iBAAA;EACA,gBAAA;AA0BF;AD4BE;ECxDA,cAAA;EACA,iBAAA;EACA,gBAAA;AA+BF;;ADuBE;EChDA,cAAA;EACA,iBAAA;AA6BF;ADkBE;EChDA,cAAA;EACA,iBAAA;AAiCF;;ADcE;ECzCA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA+BF;ADOE;ECzCA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAqCF;;AAjCA;EAOC,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA8BD;ADPE;EChCA,yBAAA;EACA,yBAAA;EACA,cAAA;AA0CF;ADZE;EChCA,yBAAA;EACA,yBAAA;EACA,cAAA;AA+CF;;ADjBE;EClBA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAuCF;ADzBE;EClBA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA8CF;;AA1CA;EAOC,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAuCD;ADzCE;ECRA,yBAAA;EACA,yBAAA;EACA,cAAA;AAoDF;AD9CE;ECRA,yBAAA;EACA,yBAAA;EACA,cAAA;AAyDF;;AA9CA;EACC,iBAAA;AAiDD;;ADvDE;ECWA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAgDF;ADhEE;ECWA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAwDF;;AApDA;EACC,iBAAA;EACA,gBAAA;AAuDD;;AApDA;EACC,iBAAA;EACA,gBAAA;AAuDD;;ADlFE;ECgCA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AAsDF;AD1FE;ECgCA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AA6DF;;ADjGE;EC0CA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA2DF;ADzGE;EC0CA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAkEF;;AA9DA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAiED;;ADvHE;EC2DA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAgEF;ADjIE;EC2DA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAyEF;;AArEA;EACC,YAAA;AAwED;;AD9IE;EC2EA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAuEF;ADxJE;EC2EA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAgFF;ADjKE;ECsFC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AA8EH;AD1KE;ECsFC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAuFH;ADnLE;ECkGC,YAAA;EACA,mBAAA;AAoFH;ADvLE;ECkGC,YAAA;EACA,mBAAA;AAwFH;;AAnFA;EACC,iBAAA;EACA,gBAAA;AAsFD;;AAnFA;EACC,YAAA;EACA,eAAA;AAsFD;;AAnFA;EACC,eAAA;AAsFD;;AAnFA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAsFD;;AAnFA;EACC,iBAAA;EACA,gBAAA;AAsFD;;ADpNE;ECmIA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAqFF;AD3NE;ECmIA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA2FF;;ADjOE;EC4IA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAyFF;AD1OE;EC4IA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAiGF;;ADlPE;ECuJA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA+FF;ADzPE;ECuJA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAqGF;;AD/PE;ECgKA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAmGF;ADtQE;ECgKA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAyGF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 1100px;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.top {\n  display: flex;\n  padding: 2rem 0;\n  overflow: auto;\n}\n@media (max-width: 900px) {\n  .top {\n    flex-direction: column;\n  }\n}\n\n:global(.theme--light) .left {\n  border-right: 1px solid #dddddd;\n  flex: 1;\n  min-width: 300px;\n  max-width: 400px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n:global(.theme--dark) .left {\n  border-right: 1px solid #2f2f2f;\n  flex: 1;\n  min-width: 300px;\n  max-width: 400px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 540px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n}\n\n.mb {\n  margin-bottom: 16px;\n}\n\n:global(.theme--light) .subHeader {\n  color: #212121;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--dark) .subHeader {\n  color: #f0f0f0;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n:global(.theme--light) .subHeaderSecondary {\n  color: #888888;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .subHeaderSecondary {\n  color: #a3a3a3;\n  font-size: 1.4rem;\n}\n\n:global(.theme--light) .fieldLabel {\n  color: #212121;\n  font-size: 1.4rem;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n:global(.theme--dark) .fieldLabel {\n  color: #f0f0f0;\n  font-size: 1.4rem;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.durationSelect {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 1.4rem;\n  cursor: pointer;\n}\n:global(.theme--light) .durationSelect {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--dark) .durationSelect {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n\n:global(.theme--light) .helperText {\n  color: #888888;\n  font-size: 1.2rem;\n  line-height: 1.4;\n  margin-top: 6px;\n  margin-bottom: 16px;\n}\n:global(.theme--dark) .helperText {\n  color: #a3a3a3;\n  font-size: 1.2rem;\n  line-height: 1.4;\n  margin-top: 6px;\n  margin-bottom: 16px;\n}\n\n.commentsTextarea {\n  resize: vertical;\n  width: 100%;\n  min-height: 100px;\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .commentsTextarea {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--dark) .commentsTextarea {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n\n.commentsTextarea::placeholder {\n  font-size: 1.4rem;\n}\n\n:global(.theme--light) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n:global(.theme--dark) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n\n.warningHeader {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.warningText {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n:global(.theme--light) .rightTopHeaders {\n  border-bottom: 1px solid #dddddd;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n:global(.theme--dark) .rightTopHeaders {\n  border-bottom: 1px solid #2f2f2f;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n\n:global(.theme--light) .buttons {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n:global(.theme--dark) .buttons {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n\n.listings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  overflow: auto;\n}\n\n:global(.theme--light) .singleListing {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .singleListing {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n\n.singleListing[data-no-border=true] {\n  border: none;\n}\n\n:global(.theme--light) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--dark) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--light) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #dddddd;\n  transition: 200ms;\n}\n:global(.theme--dark) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #2f2f2f;\n  transition: 200ms;\n}\n:global(.theme--light) .xContainer div:hover {\n  padding: 2px;\n  background: #888888;\n}\n:global(.theme--dark) .xContainer div:hover {\n  padding: 2px;\n  background: #a3a3a3;\n}\n\n.itemTextPrimary {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.secRowSeat {\n  flex-grow: 1;\n  min-width: 20px;\n}\n\n.headerSecRowSeat {\n  padding: 0.6rem;\n}\n\n.secRowSeatCont {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.textSecondary {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n:global(.theme--light) .duration {\n  color: #888888;\n  width: 80px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .duration {\n  color: #a3a3a3;\n  width: 80px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .existingComments {\n  color: #888888;\n  width: 150px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n  font-size: 1.2rem;\n  line-height: 1.3;\n}\n:global(.theme--dark) .existingComments {\n  color: #a3a3a3;\n  width: 150px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n  font-size: 1.2rem;\n  line-height: 1.3;\n}\n\n:global(.theme--light) .qty {\n  color: #888888;\n  width: 50px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .qty {\n  color: #a3a3a3;\n  width: 50px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .priceLabel {\n  color: #888888;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .priceLabel {\n  color: #a3a3a3;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BulkHoldListings-module_root___xfTrL`,
	"top": `BulkHoldListings-module_top___Nfpg3`,
	"left": `BulkHoldListings-module_left___Ogert`,
	"right": `BulkHoldListings-module_right___uoVYs`,
	"mb": `BulkHoldListings-module_mb___R1vFQ`,
	"subHeader": `BulkHoldListings-module_subHeader___yPm1L`,
	"subHeaderSecondary": `BulkHoldListings-module_subHeaderSecondary___THk5J`,
	"fieldLabel": `BulkHoldListings-module_fieldLabel___df59I`,
	"durationSelect": `BulkHoldListings-module_durationSelect___ohd6X`,
	"helperText": `BulkHoldListings-module_helperText___QncNN`,
	"commentsTextarea": `BulkHoldListings-module_commentsTextarea___jtF47`,
	"warning": `BulkHoldListings-module_warning___xFSAk`,
	"warningHeader": `BulkHoldListings-module_warningHeader___fy44K`,
	"warningText": `BulkHoldListings-module_warningText___UvpsH`,
	"rightTopHeaders": `BulkHoldListings-module_rightTopHeaders___jSnwU`,
	"buttons": `BulkHoldListings-module_buttons___AFe5O`,
	"listings": `BulkHoldListings-module_listings___ouEs7`,
	"singleListing": `BulkHoldListings-module_singleListing___RBHTo`,
	"xContainer": `BulkHoldListings-module_xContainer___N88JV`,
	"itemTextPrimary": `BulkHoldListings-module_itemTextPrimary___k58rn`,
	"secRowSeat": `BulkHoldListings-module_secRowSeat___SCR_j`,
	"headerSecRowSeat": `BulkHoldListings-module_headerSecRowSeat___KCy7h`,
	"secRowSeatCont": `BulkHoldListings-module_secRowSeatCont___I5Ya_`,
	"textSecondary": `BulkHoldListings-module_textSecondary___omxZH`,
	"duration": `BulkHoldListings-module_duration___RNC_f`,
	"existingComments": `BulkHoldListings-module_existingComments___Kz65H`,
	"qty": `BulkHoldListings-module_qty___rHOZp`,
	"priceLabel": `BulkHoldListings-module_priceLabel___PayUW`
};
export default ___CSS_LOADER_EXPORT___;
